import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-total-premium-states',
    templateUrl: './total-premium-states.component.html',
    styleUrls: ['./total-premium-states.component.scss'],
    standalone: false
})
export class TotalPremiumStatesComponent {
  @Input() state;
}
